import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchExpenses = createAsyncThunk('expenses/fetchExpenses', async ({ page = 1, type = null, categoryId = null, startDate = null, endDate = null } = {}, { rejectWithValue }) => {
  try {
    const params = { page, per_page: 20 };
    if (type) params.type = type;
    if (categoryId) params.category_id = categoryId;
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const response = await api.get('/expenses', { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener egresos');
  }
});

export const fetchExpensesSummary = createAsyncThunk('expenses/fetchExpensesSummary', async ({ categoryId = null, startDate = null, endDate = null } = {}, { rejectWithValue }) => {
  try {
    const params = {};
    if (categoryId) params.category_id = categoryId;
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const response = await api.get('/expenses/summary', { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener resumen de egresos');
  }
});

export const createExpense = createAsyncThunk('expenses/createExpense', async (expenseData, { rejectWithValue }) => {
  try {
    const response = await api.post('/expenses', expenseData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al crear egreso');
  }
});

export const updateExpense = createAsyncThunk('expenses/updateExpense', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await api.put(`/expenses/${id}`, data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al actualizar egreso');
  }
});

export const deleteExpense = createAsyncThunk('expenses/deleteExpense', async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/expenses/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al eliminar egreso');
  }
});

const expensesSlice = createSlice({
  name: 'expenses',
  initialState: {
    expenses: [],
    summary: null,
    pagination: { total: 0, pages: 1, page: 1, per_page: 20 },
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.expenses = action.payload.items;
        state.pagination = {
          total: action.payload.total,
          pages: action.payload.pages,
          page: action.payload.page,
          per_page: action.payload.per_page,
        };
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchExpensesSummary.fulfilled, (state, action) => {
        state.summary = action.payload;
      });
  },
});

export const { clearError } = expensesSlice.actions;
export default expensesSlice.reducer;
